export const environment = {
  production: process.env.REACT_APP_PRODUCTION === "true",
  type: process.env.REACT_APP_TYPE || "Local",
  dummyUuid:
    process.env.REACT_APP_DUMMY_UUID ||
    "00000000-0000-0000-0000-000000000000",
  funnelBaseUrl: process.env.REACT_APP_FUNNEL_BASE_URL || "",
  zestMerchantId: process.env.REACT_APP_ZEST_MERCHANT_ID || "",
  featureSwtichApi: process.env.REACT_APP_FEATURE_SWITCH_API || "",
  fkWhitelistAPI: process.env.REACT_APP_FK_WHITELIST_API || "",
  pricingAPIKey: process.env.REACT_APP_PRICING_API_KEY || "",
  zestPLMerchantId: process.env.REACT_APP_ZEST_PL_MERCHANT_ID || "",
  featuresApiKey: process.env.REACT_APP_FEATURES_API_KEY || "",
  storylyToken: process.env.REACT_APP_STORYLY_TOKEN || "",
};
export const PAYMENTAPPURL = process.env.REACT_APP_PAYMENT_APP_URL || "";
export const APPURL = process.env.REACT_APP_APP_URL || "";
export const QUICKPAYURL = process.env.REACT_APP_QUICK_PAY_URL || "";
export const BASEURL = process.env.REACT_APP_BASE_URL || "";
export const S3BUCKETURL = process.env.REACT_APP_S3_BUCKET_URL || "";
export const RAZORPAYID = process.env.REACT_APP_RAZORPAY_ID || "";
export const YOURACCOUNTURL = process.env.REACT_APP_YOUR_ACCOUNT_URL || "";
export const APIGATEWAYBASEURL =
  process.env.REACT_APP_API_GATEWAY_BASE_URL || "";
export const PHOTOS3BUCKETURL =
  process.env.REACT_APP_PHOTO_S3_BUCKET_URL || "";
export const PLPRICINGAPIGATEWAYBASEURL =
  process.env.REACT_APP_PL_PRICING_API_GATEWAY_BASE_URL || "";
export const STATICWEBSITEURL = process.env.REACT_APP_STATIC_WEBSITE_URL || "";
export const PAYTMTRANSACTIONURL =
  process.env.REACT_APP_PAYTM_TRANSACTION_URL || "";
export const APIURL = process.env.REACT_APP_API_URL || "";
export const LENDERURL = process.env.REACT_APP_LENDER_URL || "";
export const CMSURL = process.env.REACT_APP_CMS_URL || "";
export const FEATURESWITCHBASEURL =
  process.env.REACT_APP_FEATURE_SWITCH_BASE_URL || "";
export const BOLTMYACCOUNTSURL =
  process.env.REACT_APP_BOLT_MY_ACCOUNTS_URL || "";
export const BASEAPIURL = process.env.REACT_APP_BASE_API_URL || "";
export const AUTHURL = process.env.REACT_APP_AUTH_URL || "";
export const BASEAPIKEY = process.env.REACT_APP_BASE_API_KEY || "";
export const MAXPRECLOSURECASHBACK = Number(
  process.env.REACT_APP_MAX_PRECLOSURE_CASHBACK || 0,
);
export const STATICCMSURL = process.env.REACT_APP_STATIC_CMS_URL || "";

// --- Auth SDK Config ---
export const AUTH_ENV_NAME = process.env.REACT_APP_AUTH_ENV_NAME || "staging";
export const AUTH_API_KEY = process.env.REACT_APP_AUTH_API_KEY || "";
export const AUTH_GOOGLE_CLIENT_ID = process.env.REACT_APP_AUTH_GOOGLE_CLIENT_ID || "";
export const AUTH_TRUECALLER_APP_KEY = process.env.REACT_APP_AUTH_TRUECALLER_APP_KEY || "";
export const AUTH_FINORAMIC_CLIENT_ID = process.env.REACT_APP_AUTH_FINORAMIC_CLIENT_ID || "";
export const AUTH_WEBENGAGE_KEY = process.env.REACT_APP_AUTH_WEBENGAGE_KEY || "";
export const AUTH_MOENGAGE_KEY = process.env.REACT_APP_AUTH_MOENGAGE_KEY || "";
export const AUTH_ENABLE_GOOGLE = process.env.REACT_APP_AUTH_ENABLE_GOOGLE === "true";
export const AUTH_ENABLE_TRUECALLER = process.env.REACT_APP_AUTH_ENABLE_TRUECALLER === "true";
export const AUTH_ENABLE_FINORAMIC = process.env.REACT_APP_AUTH_ENABLE_FINORAMIC === "true";
export const AUTH_ENABLE_ANALYTICS = process.env.REACT_APP_AUTH_ENABLE_ANALYTICS === "true";
export const AUTH_ENABLE_DEBUG = process.env.REACT_APP_AUTH_ENABLE_DEBUG === "true";

export const GCMerchantsList = {
  Flipkart: {
    name: "Flipkart",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/flipkart.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=flipkart`,
    dashboard_websiteUrl:
      `${BASEURL}/emi/flipkart-product`,
    isAbsolute: false,
  },
  Amazon: {
    name: "Amazon",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/amazon.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=amazon`,
    dashboard_websiteUrl: `${BASEURL}/emi/amazon-product`,
    isAbsolute: false,
  },
  MakeMyTrip: {
    name: "MakeMyTrip",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/makemytrip.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=makemytrip`,
    dashboard_websiteUrl: `${STATICWEBSITEURL}/partner/makemytrip/`,
    isAbsolute: false,
  },
  Mi: {
    name: "Mi",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/mi.png`,
    websiteUrl: "https://www.mi.com/in/",
    dashboard_websiteUrl: "https://www.mi.com/in/",
    isAbsolute: true,
  },
  Myntra: {
    name: "Myntra",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/myntra.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=myntra`,
    dashboard_websiteUrl: `${STATICWEBSITEURL}/myntra/`,
    isAbsolute: false,
  },
  Uber: {
    name: "Uber",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/uber.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=uber`,
    dashboard_websiteUrl: `${STATICWEBSITEURL}/uber/`,
    isAbsolute: false,
  },
  BookMyShow: {
    name: "BookMyShow",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/bookmyshow.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=bookmyshow`,
    dashboard_websiteUrl: `${STATICWEBSITEURL}/bookmyshow/`,
    isAbsolute: false,
  },
  Jabong: {
    name: "Jabong",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/jabong.png`,
    websiteUrl:
      `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=jabong`,
    dashboard_websiteUrl: `${STATICWEBSITEURL}/jabong/`,
    isAbsolute: false,
  },
  Flomattress: {
    name: "Flomattress",
    photoUrl:
      `${S3BUCKETURL}/my_accounts_merchants/merchant_logos/flomattress.png`,
    websiteUrl: "https://www.flomattress.com",
    dashboard_websiteUrl: "https://www.flomattress.com",
    isAbsolute: true,
  },
};

export const whiteListUrl = {
  Flipkart: "http://fkrt.it/fEIM5zuuuN",
  AmazonPay:
    "https://www.amazon.in/?&_encoding=UTF8&tag=zestmoney-21&linkCode=ur2&linkId=9577f7adc0716e5a8b2c7d4336468f19&camp=3638&creative=24630",
};
